import { TextField, Paper, Table, TableHead, TableRow, TableCell, TableBody, TablePagination, Box } from "@mui/material";
import Wrapper from "../components/Wrapper";
import { useEffect, useState } from "react";
import { listService } from "../services/services";
import moment from "moment";

const Services = () => {

  const [services, set_services] = useState([]);
  const [page, set_page] = useState(0);
  const [count, set_count] = useState(0);
  const [search, set_search] = useState('');

  const getData = async () => {
    const { data } = await listService({
      page: page,
      limit: 10,
      search: search
    })

    if (data) {
      set_services(data.data);
      set_count(data.total_records);
    }
  }

  const handleChangePage = (event, page_no) => {
    set_page(page_no)
  }

  useEffect(() => {
    getData();

    // eslint-disable-next-line
  }, [page, search])

  return(
    <Wrapper>
      <Box
        component='div'
        display='flex'
        justifyContent='space-between'
        alignItems='center'
      >
        <TextField
          label='Search'
          sx={{
            width: '450px'
          }}
          value={search}
          onChange={(e) => set_search(e.target.value)}
        />
      </Box>

      <Paper
        elevation={4}
        sx={{
          marginTop : '20px'
        }}
      >
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>
                Sr No.
              </TableCell>
              <TableCell>
                Name
              </TableCell>
              <TableCell>
                Provided By
              </TableCell>
              <TableCell>
                Price
              </TableCell>
              <TableCell>
                Status
              </TableCell>
              <TableCell>
                Created At
              </TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {
              services.map((service, ind) => {
                return(
                  <TableRow key={service._id}>
                    <TableCell>
                      {ind + 1}
                    </TableCell>
                    <TableCell>
                      {service.name}
                    </TableCell>
                    <TableCell>
                      {service.created_by_user.name}
                    </TableCell>
                    <TableCell>
                      {service.price} / {service.price_per}
                    </TableCell>
                    <TableCell>
                      {service.active ? 'Active' : 'Inactive'}
                    </TableCell>
                    <TableCell>
                      {moment(service.created_at).format('DD-MM-YYYY hh:mm A')}
                    </TableCell>
                  </TableRow>
                )
              })
            }
          </TableBody>
        </Table>

        <TablePagination
          component="div"
          count={count}
          page={page}
          rowsPerPage={10}
          rowsPerPageOptions={[]}
          onPageChange={handleChangePage}
        />
      </Paper>

    </Wrapper>
  )
}

export default Services;